export const ETHERSCAN_URL = 'https://etherscan.io';

export const MINTSCAN_URL = 'https://www.mintscan.io/dydx';
